// src/data/files.js
export const filesData = {
    all: [
      { id: 1, name: 'Divorce Case', date: 'Apr 2, 2024', color: 'bg-pink-200' },
      { id: 2, name: 'New Work Case', date: 'Apr 2, 2024', color: 'bg-green-200' },
      { id: 3, name: 'Workplace Case', date: 'Apr 2, 2024', color: 'bg-yellow-200' },
    ],
    personal: [
      { id: 4, name: 'Personal Projects', date: 'Apr 2, 2024', color: 'bg-blue-200' },
      { id: 5, name: 'Self-improvement', date: 'Apr 2, 2024', color: 'bg-indigo-200' },
    ],
    customer: [
      { id: 6, name: 'Employees Case', date: 'Apr 2, 2024', color: 'bg-red-200' },
      { id: 7, name: 'Employers Case', date: 'Apr 2, 2024', color: 'bg-purple-200' },
    ],
  };
  